export default {
    props: ['serviceName'],
    data() {
        return {
            service: null
        };
    },
    created() {
        this.loadService();
    },
    methods: {
        async loadService() {
            let response = await import(`../services/${this.serviceName}`)
            this.service = response.default;
        },
    }
}